import { render } from "./WhatsAppMessage.vue?vue&type=template&id=219312ae&scoped=true"
import script from "./WhatsAppMessage.vue?vue&type=script&lang=js"
export * from "./WhatsAppMessage.vue?vue&type=script&lang=js"

import "./WhatsAppMessage.vue?vue&type=style&index=0&id=219312ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219312ae"]])

export default __exports__